import {
  ImageBackground,
  StyleSheet,
  useWindowDimensions,
  SafeAreaView,
  Image,
} from "react-native";
import React, { useEffect, useState } from "react";
import { StackScreenProps } from "../../types";
import {
  View,
  Text,
  Heading,
  Pressable,
  ScrollView,
  Box,
  HStack,
  Flex,
} from "native-base";
import Header from "../../components/Header";
import CountUp from "react-countup";
import AsyncStorage from "@react-native-async-storage/async-storage";

const slideItems = [
  {
    text: "Detailed soil survey and soil fertility mapping to enhance management of problematic soils. ",
    image: require("../../assets/vectors/survey.png"),
  },
  {
    text: "Dissemination of innovation and technologies for managing problematic soils in Nigeria.",
    image: require("../../assets/vectors/box.png"),
  },
  {
    text: "Evaluation of small-scale demonstration plots for promoting participatory evaluation of technologies and training of farmers on farmers’ fields.",
    image: require("../../assets/vectors/chart.png"),
  },
  {
    text: "Technology diffusion and sensitization of demonstration plots results for improved crop production and livelihood.",
    image: require("../../assets/vectors/plant.png"),
  },
  {
    text: "Sensitization of the private sector, financial institutions, and policymakers on the management of problematic soils.",
    image: require("../../assets/vectors/finance.png"),
  },
];

type RenderItemProps = {
  item: any[];
  index: number;
};
const renderItem = ({ item, index }: RenderItemProps) => (
  <Box
    w={300}
    h={350}
    mb={5}
    rounded={"md"}
    margin="auto"
    key={index}
    alignSelf="center"
  >
    <ImageBackground
      source={item}
      resizeMode="cover"
      style={{
        width: "100%",
        height: "100%",
      }}
      imageStyle={{ borderRadius: 10 }}
    ></ImageBackground>
  </Box>
);

const EMAY = ({ navigation }: StackScreenProps<"CropResearch">) => {
  const { width, height } = useWindowDimensions();

  const [data, setData] = useState({});
  useEffect(() => {
    async function getData() {
      const items = await AsyncStorage.getItem("keyFigures");

      if (items) {
        try {
          setData(JSON.parse(items));
          // console.log(JSON.parse(items));
        } catch (error) {
          console.log(error);
        }
      }
    }

    getData();
  }, []);

  return (
    <View style={styles.container}>
      <ImageBackground
        source={require("../../assets/grains.png")}
        resizeMode="cover"
        style={{ width, height }}
      >
        <View style={styles.overlay}>
          <SafeAreaView style={{ height }}>
            <ScrollView
              px="6"
              contentContainerStyle={{
                flex: 1,
                paddingBottom: 20,
              }}
            >
              <Header
                onPress={() => navigation.navigate("FarmInitiatives")}
                parentText="Farm Initiatives"
                headingText="Empowering Africa Youth (EMAY)"
              />

              <Text
                textAlign="center"
                fontWeight="bold"
                mb={5}
                fontFamily="Rajdhani-Bold"
              >
                Key Figures
              </Text>

              <Box
                width={"100%"}
                // h="16"
                mb={5}
                margin="auto"
                // borderBottomColor="#000"
                borderColor={"#555"}
                borderWidth="1"
                borderRadius={15}
                p={5}
                pb={2}
              >
                <HStack justifyContent={"space-between"}>
                  <View w={"30%"}>
                    <Text
                      fontWeight={"extrabold"}
                      fontSize="2xl"
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      <CountUp delay={0} end={data["emay_1"]} duration={2} />
                    </Text>
                    <Text
                      fontWeight={"bold"}
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      Young Leaders
                    </Text>
                  </View>
                  <View w={"30%"}>
                    <Text
                      fontWeight={"extrabold"}
                      fontSize="2xl"
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      <CountUp
                        delay={0}
                        end={data["emay_2"]}
                        duration={3}
                        suffix="+"
                      />
                    </Text>
                    <Text
                      fontWeight={"bold"}
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      Farmers Reached
                    </Text>
                  </View>
                  <View w={"30%"}>
                    <Text
                      fontWeight={"extrabold"}
                      fontSize="2xl"
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      <CountUp delay={0} end={data["emay_3"]} suffix="Ha" />
                    </Text>
                    <Text
                      fontWeight={"bold"}
                      fontFamily="Rajdhani-Bold"
                      textAlign={"center"}
                    >
                      Soil Analysis Coverage
                    </Text>
                  </View>
                </HStack>
              </Box>

              <Text textAlign="center" mb={5} mt={10}>
                Launched in 2020, Empowering African Youth (EMAY) is a program
                that supports youth participation in the agriculture called
                Young Leaders. The project empowers Young Leaders in Africa to
                become agents of positive change, influencers and enablers for
                Agricultural growth using technology solutions. Through the EMAY
                initiative, Young Leaders are trained and equipped with tools
                such as; mobile soil testing laboratory, tablets and tricycles
                to provide support and advisory services to smallholder farmers
                within their communities for improved yields and income.
              </Text>

              <Text textAlign="center">
                Initiated in 2017, the project has been deployed across 9
                agricultural value-chain in 17 states. In addition to the core
                Agribooster Offer, the project has supported communities with
                greenhouses, Motorcycles, Tablets, boreholes, moisture meters
                and weighing scales.
              </Text>

              <Text textAlign="center" fontWeight={"bold"} mb="5" mt={10}>
                EMAY Value Addition
              </Text>

              <View alignSelf="center" mb={10}>
                <Text>-- Training and Extension Services</Text>
                <Text>-- Soil testing and Fertilizer Recommendation</Text>
                <Text>-- -Access to quality farm input</Text>
                <Text>-- Demo Plot</Text>
                <Text>-- Job creation – as entrepreneurs</Text>
                <Text>-- Digital Technology</Text>
                <Text>-- -Specialized Fertilizers</Text>
              </View>

              <View mb={20}>
                {/* <Swiper controlsEnabled={true}> */}
                {[
                  require("../../assets/gallery/emay/Farm-and-Fortune-1-min.jpg"),
                  require("../../assets/gallery/emay/Farm-and-Fortune-2-min.jpg"),
                  require("../../assets/gallery/emay/Farm-and-Fortune-3-min.jpg"),
                  require("../../assets/gallery/emay/Farm-and-Fortune-4-min.jpg"),
                  require("../../assets/gallery/emay/Farm-and-Fortune-5-min.jpg"),
                  require("../../assets/gallery/emay/Farm-and-Fortune-6-min.jpg"),
                  require("../../assets/gallery/emay/Farm-and-Fortune-7-min.jpg"),
                ].map((item, index) => renderItem({ item, index }))}
                {/* </Swiper> */}
              </View>

              <View mt={10}></View>
            </ScrollView>
          </SafeAreaView>
        </View>
      </ImageBackground>
    </View>
  );
};

export default EMAY;

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  imageContainer: {
    flex: 1,
  },
  overlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "#923a03c7",
  },
  slideContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  slide1: {
    backgroundColor: "rgba(20,20,200,0.3)",
  },
  slide2: {
    backgroundColor: "rgba(20,200,20,0.3)",
  },
  slide3: {
    backgroundColor: "rgba(200,20,20,0.3)",
  },
});
